import { Suspense } from 'react';
import type { Agent } from '@/lib/types';
import type { AgentAction } from './useAgentActions';

export interface AgentActionDialogsProps {
  actions: AgentAction[];
  agent: Agent;
  /** Key of the dialog action currently open, or null when no dialog is open. */
  openKey: string | null;
  onOpenKeyChange: (key: string | null) => void;
}

/**
 * Renders the dialog for the currently active dialog-kind {@link AgentAction}.
 *
 * Must be mounted as a sibling of the DropdownMenu rather than inside its
 * `DropdownMenuContent`: Radix unmounts menu content when the menu closes
 * after item selection, and a Dialog mounted alongside the item would unmount
 * with it — the modal would flash and immediately disappear.
 */
export function AgentActionDialogs({
  actions,
  agent,
  openKey,
  onOpenKeyChange,
}: AgentActionDialogsProps) {
  const active = openKey ? actions.find((a) => a.key === openKey) : null;
  if (!active || active.kind !== 'dialog') return null;
  const Dialog = active.Dialog;
  return (
    <Suspense>
      <Dialog
        agent={agent}
        open
        onOpenChange={(next) => {
          if (!next) onOpenKeyChange(null);
        }}
      />
    </Suspense>
  );
}
